export default __webpack_public_path__ + "static/media/hubi1.5b2605a0.png";